import { render, staticRenderFns } from "./CheckboxGroupField.vue?vue&type=template&id=234c7b51&scoped=true&"
import script from "./CheckboxGroupField.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroupField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGroupField.vue?vue&type=style&index=0&id=234c7b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c7b51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VInput,VRow})
